export default __webpack_public_path__ + "static/media/ILPlatform_Books.401411e1.png";